import React from "react";
import "../styles/AboutUs.css";

const AboutUs = () => {
  return (
    <section className="AboutUsSection" aria-labelledby="aboutUsTitle">
      <h2 id="aboutUsTitle">DISCOVER OUR TEAM</h2>
      <div className="AboutUsSection__Team">
        <article
          className="AboutUsSection__Team--person"
          aria-labelledby="GuillermoRole"
        >
          <img
            src="/images/guillermo.webp"
            width="200"
            height="200"
            alt="Guillermo Azcona"
            aria-label="Guillermo Azcona, a BookRealm developer focused on React interactions."
          />
          <div className="person-details">
            <h3 id="GuillermoRole">GUILLERMO AZCONA</h3>
            <p>
              BookRealm developer. The React interaction student focuses on
              creating interactive and dynamic components using React. He is
              responsible for developing the user interface logic, managing the
              application's state, and ensuring a smooth user experience. They
              work closely with the design and development team to integrate
              their components into the web project.
            </p>
          </div>
        </article>
        <article
          className="AboutUsSection__Team--person"
          aria-labelledby="EduardoRole"
        >
          <img
            src="/images/eduardo.webp"
            width="200"
            height="200"
            alt="Eduardo Ezponda"
            aria-label="Eduardo Ezponda, responsible for SEO optimization at BookRealm."
          />
          <div className="person-details">
            <h3 id="EduardoRole">EDUARDO EZPONDA</h3>
            <p>
              BookRealm developer. The SEO student is responsible for optimizing
              the website's content to improve its visibility in search engines.
              His work includes keyword research, meta tag optimization, and
              creating link-building strategies to increase organic traffic to
              the site.
            </p>
          </div>
        </article>
        <article
          className="AboutUsSection__Team--person"
          aria-labelledby="HelenRole"
        >
          <img
            src="/images/helen.webp"
            width="200"
            height="200"
            alt="Helen Portuondo"
            aria-label="Helen Portuondo, a designer at BookRealm focusing on user interface design."
          />
          <div className="person-details">
            <h3 id="HelenRole">HELEN PORTUONDO</h3>
            <p>
              BookRealm developer. The design student specializes in the visual
              design and usability of the website. She works on creating
              attractive and functional interfaces, focusing on user experience.
              They use design tools such as Figma to create prototypes and
              collaborate closely with the development team to implement their
              designs.
            </p>
          </div>
        </article>
      </div>
    </section>
  );
};

export default AboutUs;
